import React, { PureComponent } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { Button } from '@3plearning/react-components';
import css from './strength-weakness-tab.scss';
import {
    STRENGTH_TAB,
    WEAKNESS_TAB
} from '../../containers/activity-mastery/common/strength-and-weaknesses-constants';

class StrengthWeaknessTab extends PureComponent {
    constructor(props) {
        super(props);
        this.i18n = window.i18n;
    }
    render() {
        const { isStrengthTab, children, onTabClick } = this.props;
        return (
            <div className={css.component}>
                <div className={css['tab-container']}>
                    <Button
                        className={isStrengthTab ? css.active : css.inactive}
                        onClick={() => onTabClick(STRENGTH_TAB)}
                        text={this.i18n._('Button Label - Strengths')}
                    />
                    <Button
                        className={!isStrengthTab ? css.active : css.inactive}
                        onClick={() => onTabClick(WEAKNESS_TAB)}
                        text={this.i18n._('Label - RelativeWeaknesses')}
                    />
                </div>
                <div className="strength-weakness-table">{children}</div>
            </div>
        );
    }
}

StrengthWeaknessTab.propTypes = {
    children: PropTypes.node,
    isStrengthTab: PropTypes.bool,
    onTabClick: PropTypes.func
};

export default styleable(css)(StrengthWeaknessTab);



// WEBPACK FOOTER //
// ./components/strength-weakness-tab/strength-weakness-tab.js